import { AppContext, AppLanguage } from 'config/enums'
import { SUPPORT_PAGE_TAG } from 'config/tags'
import { PF_BASE_DEEP_LINK } from 'config/constants'

import { interWbSession, interWbNavigate } from '@interco/inter-webview-bridge'
import { Theme } from '@interco/inter-ui'

export const getContext = (organization: string, orgQueryParam: string | null) => {
  if (orgQueryParam === 'US_BRANCH') return AppContext.UB
  if (organization === 'US') return AppContext.IA
  if (organization === 'AR') return AppContext.AR
  if (organization === 'PJ') return AppContext.PJ

  return AppContext.PF
}

export const getLanguage = (context: AppContext, language: string) => {
  if (context === AppContext.IA || context === AppContext.AR || context === AppContext.UB) {
    if (language.startsWith(AppLanguage.EN)) return AppLanguage.EN
    if (language.startsWith(AppLanguage.ES)) return AppLanguage.ES
  }

  return AppLanguage.PT
}

export const getTheme = (application: string) => (application === 'PJ' ? Theme.PJ : Theme.PF)

export const openDeeplink = (path: string, contentName: string, userSegmentation?: string) => {
  const isAbsolute = /^(mailto:|tel:)/.test(path)

  const finalLink = isAbsolute ? path : `${PF_BASE_DEEP_LINK}${path}`
  interWbNavigate.openDeepLink(finalLink)

  interWbSession.requestAnalytics(SUPPORT_PAGE_TAG, {
    content_name: contentName,
    tela: 'Canais de Atendimento',
    content_action: 'clique',
    content_id: userSegmentation ?? '',
  })
}
